module.exports = __webpack_public_path__ + "static/media/registSalesUp1.ccfc0cb5.svg";